export const AdminModule = {
  state: {},
  getters: {},
  actions: {},
  mutations: {},
};
